<template>
  <div id="filter_channel">
    <div class="widget-12-search">
      <div class="col-md-12 p-l-0 p-r-0">
        <div class="row" id="filter-channel">
          <div class="m-t-5 m-b-5 col-md-11">
            <h5 class="m-b-0">Filter Saluran</h5>
            <p class="small hint-text">Filter data berdasarkan saluran</p>
          </div>
          <div v-if="collapse" class="p-t-15 col-md-1">
            <i v-if="collapseDefault == 'none'" class="bi bi-chevron-right clickable hoverable"
              @click="showCardContent" />
            <i v-else class="bi bi-chevron-down clickable hoverable" @click="showCardContent" />
          </div>
        </div>
      </div>
      <div class="clearfix" />
    </div>
    <div class="company-stat-boxes" :id="param_name + '-lists'" :style="'display: ' + collapseDefault">
      <div class="company-stat-box active p-l-5 p-r-5 p-t-10 p-b-10 b-b b-grey hoverable clickable"
        @click="setFilter($event, 'Medsos')" :class="[
          {
            'filter-active': filterChannel === 'Medsos' && isActiveMedsos,
          },
        ]">
        <div class="pull-left">
          <p class="company-name pull-left text-uppercase bold no-margin" style="
              display: flex;
              justify-content: center;
              align-items: center;
              height: 20px;
              width: 100%;
            ">
            <span class="bi bi-heart-fill mr-2" />
            <span style="
                vertical-align: middle !important;
                display: inline-block;
                line-height: normal;
                text-transform: capitalize;
                font-size: 14px;
              ">
              Media Sosial
            </span>
          </p>
        </div>
        <div class="pull-right">
          <p class="bold no-margin inline thousand-separator">
            {{ thousand_separator(totalMedsos) }}
          </p>
        </div>
        <div class="clearfix" />
      </div>
      <div class="company-stat-box active p-l-5 p-r-5 p-t-10 p-b-10 b-b b-grey hoverable clickable"
        @click="setFilter($event, 'Medkon')" :class="[
          {
            'filter-active': filterChannel === 'Medkon' && isActiveMedkon,
          },
        ]">
        <div class="pull-left">
          <p class="company-name pull-left text-uppercase bold no-margin" style="
              display: flex;
              justify-content: center;
              align-items: center;
              height: 20px;
              width: 100%;
            ">
            <span class="bi bi-globe-americas mr-2" />
            <span style="
                vertical-align: middle !important;
                display: inline-block;
                line-height: normal;
                text-transform: capitalize;
                font-size: 14px;
              ">
              Media Online
            </span>
          </p>
        </div>
        <div class="pull-right">
          <p class="bold no-margin inline thousand-separator">
            {{ thousand_separator(totalMedkon) }}
          </p>
        </div>
        <div class="clearfix" />
      </div>
    </div>
  </div>
</template>
<script>
import $ from "jquery";
import general_plugin from "@/plugins/generalPlugins.js";
import moment from "moment";
export default {
  name: "filter_channel",
  props: {
    param_name: String,
    collapse: String,
    collapseDefault: String,
    totalMedsos: Number,
    totalMedkon: Number,
  },
  data() {
    return {
      filterChannel: "",
      isActiveMedkon: false,
      isActiveMedsos: false,
      isActiveChannel: this.$store.getters.user.project.project_detail.crawler,
    };
  },
  methods: {
    thousand_separator: function (str) {
      return general_plugin.thousandSeparator(str);
    },
    showCardContent: function (event) {
      var card_header = $(event.target).closest(".widget-12-search");
      var isVisible = card_header.next().css("display");
      if (isVisible == "none") {
        card_header.next().slideDown();
        $(event.target).removeClass("bi bi-chevron-right");
        $(event.target).addClass("bi bi-chevron-down");
      } else {
        card_header.next().slideUp();
        $(event.target).removeClass("bi bi-chevron-down");
        $(event.target).addClass("bi bi-chevron-right");
      }
    },
    setFilter: function (event, filter) {
      var div_container = $(event.target).closest(".company-stat-box");
      let available_filter = this.$route.query["sources"];
      if (available_filter != null) {
        if (filter == "Medsos" && this.isActiveMedsos) {
          this.filterChannel = "";
          this.isActiveMedsos = false;
          div_container
            .parent()
            .children()
            .first()
            .removeClass("filter-active");
          this.filter("");
        } else if (filter == "Medkon" && this.isActiveMedkon) {
          this.filterChannel = "";
          this.isActiveMedkon = false;
          div_container
            .parent()
            .children()
            .first()
            .removeClass("filter-active");
          this.filter("");
        } else {
          this.filterChannel = filter;
          this.isActiveMedsos = filter == "Medsos" ? true : false;
          this.isActiveMedkon = filter == "Medkon" ? true : false;
          div_container.parent().children().first().addClass("filter-active");
          this.filter(filter);
        }
      } else {
        this.filter(filter);
      }
    },
    filter: function (filter) {
      let sources = [];
      let start = "";
      let end = "";
      let params = {};
      if (filter === "Medsos") {
        this.filterChannel = "Medsos";
        this.isActiveMedsos = true;
        this.isActiveMedkon = false;
        sources = [];
        if (this.isActiveChannel.facebook.status == 1) {
          sources.push("facebook");
        }
        if (this.isActiveChannel.twitter.status == 1) {
          sources.push("twitter");
        }
        if (this.isActiveChannel.instagram.status == 1) {
          sources.push("instagram");
        }
        if (this.isActiveChannel.tiktok.status == 1) {
          sources.push("tiktok");
        }
        if (this.isActiveChannel.youtube.status == 1) {
          sources.push("youtube");
        }
        if (this.isActiveChannel.google.forum_status == 1) {
          sources.push("forum");
        }
        if (this.isActiveChannel.google.blog_status == 1) {
          sources.push("blog");
        }
        if (this.isActiveChannel.linkedin.status == 1) {
          sources.push("linkedin");
        }
        if ("review" in this.isActiveChannel) {
          if (this.isActiveChannel.review.status == 1) {
            sources.push("review");
          }
        }
      } else if (filter === "Medkon") {
        this.filterChannel = "Medkon";
        this.isActiveMedsos = false;
        this.isActiveMedkon = true;
        sources = [];
        if (this.isActiveChannel.formed.cetak_status == 1) {
          sources.push("media_cetak");
        }
        if (this.isActiveChannel.formed.tv_status == 1) {
          sources.push("media_tv");
        }
        if (this.isActiveChannel.google.news_status == 1) {
          sources.push("news");
        }
      }

      start = moment(this.$route.query.from).format("YYYY-MM-DD HH:mm:ss");
      end = moment(this.$route.query.to).format("YYYY-MM-DD HH:mm:ss");
      params = {
        from: start,
        to: end,
        page: 1,
      };

      if (sources.length > 0) {
        params.sources = btoa(sources.toString());
      }

      let queries = JSON.parse(JSON.stringify(this.$route.query));
      queries = { ...queries, ...params }

      this.$router.replace({ query: queries });
    },
    initFitler: function () {
      let available_filter = this.$route.query["sources"];
      if (available_filter != null) {
        available_filter = atob(available_filter);
        available_filter = available_filter.split(",");
        if (
          available_filter.includes(
            "facebook",
            "twitter",
            "instagram",
            "tiktok",
            "youtube",
            "forum",
            "blog",
            "linkedin",
            "review"
          ) &&
          available_filter.length > 0
        ) {
          this.filterChannel = "Medsos";
          this.isActiveMedsos = true;
          this.isActiveMedkon = false;
        } else if (
          available_filter.includes("news", "media_tv", "media_cetak") &&
          available_filter.length > 0
        ) {
          this.filterChannel = "Medkon";
          this.isActiveMedsos = false;
          this.isActiveMedkon = true;
        } else {
          this.isActiveMedsos = false;
          this.isActiveMedkon = false;
        }
      }
    },
  },
  watch: {
    $route() {
      this.initFitler();
    },
  },
  mounted: function () {
    this.initFitler();
  },
};
</script>

<style scoped>
.fa,
.fab {
  font-size: 25px;
  margin-right: 5px;
  width: 35px;
}

.filter-style {
  cursor: pointer;
}

.filter-style:hover {
  background: #f8f9fa;
}

.filter-active {
  background: #d3eeff;
  color: #000;
}

.filter-active:hover {
  background: #fffde1;
}

.source-disable {
  color: darkgrey;
  cursor: default;
}

@import "/assets/plugins/bootstrap-social/bootstrap-social.css";
</style>
